// 256-word list for recovery phrase generation.
// Each byte (0-255) maps to one word → 12 words = 96 bits of entropy.

const WORDS = [
  'able','acid','age','aid','air','ant','arch','arm','art','ash',
  'axe','bag','ball','band','bank','bar','base','bath','beam','bean',
  'bear','beat','belt','bind','bird','bite','blade','blast','bleed','blind',
  'blood','blow','blue','boat','body','bold','bone','book','bow','box',
  'brace','brave','brick','bright','bring','broad','brown','brush','build','burn',
  'cage','calm','card','care','cast','cave','cell','chain','chair','chalk',
  'check','chest','chip','clap','clay','cliff','clip','clock','close','coat',
  'cold','corn','count','crash','crop','crow','crush','cube','curl','dance',
  'dare','dark','dawn','deal','deep','deny','dice','dig','dome','door',
  'dove','down','draft','draw','drift','drink','drop','drum','dust','dwell',
  'east','edge','empty','even','face','fail','fair','fall','farm','fast',
  'fate','fear','feed','feel','fence','file','fill','film','find','fire',
  'firm','flag','flat','flow','foam','fold','fool','fork','form','free',
  'frost','fund','fuse','gain','gate','gift','glow','glue','grab','grain',
  'grant','grass','grave','grip','grow','guard','guide','gulf','gust','hall',
  'hand','harm','hawk','heal','heat','herb','hill','hint','hold','hole',
  'hook','horn','hour','hunt','idle','iron','jade','join','jump','keep',
  'kick','kind','king','knot','lake','lamp','land','leaf','left','lend',
  'lift','lime','link','lion','list','lock','loom','loud','luck','lure',
  'mace','make','mall','mane','mark','mask','mass','melt','mesh','mild',
  'mill','mint','mist','moon','moss','mound','move','nail','nest','node',
  'north','note','oath','only','open','oven','pack','page','palm','park',
  'part','past','path','pave','peak','pier','pile','pine','pipe','plan',
  'plum','poem','point','pool','port','pour','pull','pump','pure','push',
  'rack','rain','rank','ray','reed','reef','rent','ride','ring','rise',
  'road','rock','rope','rose','ruin','rule',
];

// WORDS must have exactly 256 entries
if (WORDS.length !== 256) {
  throw new Error(`wordlist must have 256 entries, got ${WORDS.length}`);
}

/**
 * Generate a recovery phrase of `count` words (default 12).
 * Returns an array of words.
 */
export function generateRecoveryPhrase(count = 12) {
  const bytes = new Uint8Array(count);
  crypto.getRandomValues(bytes);
  return Array.from(bytes).map((b) => WORDS[b]);
}

/**
 * Validate that a recovery phrase contains only words from the list.
 * Returns true if valid, false otherwise.
 */
export function validateRecoveryPhrase(words) {
  return words.every((w) => WORDS.includes(w.toLowerCase().trim()));
}
